import { render, staticRenderFns } from "./StatementViewer.vue?vue&type=template&id=0d0c68f5&scoped=true&"
import script from "./StatementViewer.vue?vue&type=script&lang=js&"
export * from "./StatementViewer.vue?vue&type=script&lang=js&"
import style0 from "./StatementViewer.vue?vue&type=style&index=0&id=0d0c68f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c68f5",
  null
  
)

export default component.exports